import { Action } from 'redux';
import { GetOpenEnrollmentRule } from 'src/app/angular-elements/form-wrappers/family-form/types/qualifying-life-event.response.interface';

// State interface
export interface SepLifeEventFormState {
  lifeEventDateValue: string;
  selectedLifeEvent: GetOpenEnrollmentRule;
  selectedLifeEventId: string;
  fetchFromConfig: boolean;
  // add other SEP fields as needed
}

// Initial state
export const INITIAL_SEP_LIFE_EVENT_STATE: SepLifeEventFormState = {
  lifeEventDateValue: null,
  selectedLifeEvent: null,
  selectedLifeEventId: null,
  fetchFromConfig: null
};

// Action types
const SET_LIFE_EVENT_DATE = 'SET_LIFE_EVENT_DATE';
const SET_LIFE_EVENT_ID = 'SET_LIFE_EVENT_ID';
const SET_LIFE_EVENT = 'SET_LIFE_EVENT';
const SET_FETCH_FORM_CONFIG = 'SET_FETCH_FORM_CONFIG';
export const CLEAR_SEP_FORM_DATA = 'CLEAR_SEP_FORM_DATA';

// Action interface
export interface SepLifeEventAction extends Action {
  type: string;
  lifeEventDateValue?: string;
  selectedLifeEvent?: GetOpenEnrollmentRule,
  selectedLifeEventId?: string,
  fetchFromConfig?: boolean
}

// Action creator - use this to SET the value
export function setLifeEventDate(lifeEventDateValue: string): SepLifeEventAction {
  return { type: SET_LIFE_EVENT_DATE, lifeEventDateValue };
}

export function setSelectedLifeEventId(selectedLifeEventId: string): SepLifeEventAction {
  return { type: SET_LIFE_EVENT_ID, selectedLifeEventId };
}

export function setSelectedLifeEvent(selectedLifeEvent: GetOpenEnrollmentRule): SepLifeEventAction {
  return { type: SET_LIFE_EVENT, selectedLifeEvent };
}

export function setFetchFormConfig(fetchFromConfig: boolean): SepLifeEventAction {
  return { type: SET_FETCH_FORM_CONFIG, fetchFromConfig };
}

export function clearSepFormData(): SepLifeEventAction {
  return { type: CLEAR_SEP_FORM_DATA };
}

// Reducer name - this becomes the key in componentStates
export const SEP_LIFE_EVENT_REDUCER_NAME = 'SepLifeEventForm';

// Reducer function
export function SepLifeEventFormReducer(
  state: SepLifeEventFormState = INITIAL_SEP_LIFE_EVENT_STATE,
  action: SepLifeEventAction
): SepLifeEventFormState {
  switch (action.type) {
    case SET_LIFE_EVENT_DATE:
      return { ...state, lifeEventDateValue: action.lifeEventDateValue };
    case SET_LIFE_EVENT_ID:
      return { ...state, selectedLifeEventId: action.selectedLifeEventId };
    case SET_LIFE_EVENT:
      return { ...state, selectedLifeEvent: action.selectedLifeEvent };
    case SET_FETCH_FORM_CONFIG:
      return { ...state, fetchFromConfig: action.fetchFromConfig };
    case CLEAR_SEP_FORM_DATA:
      return { ...INITIAL_SEP_LIFE_EVENT_STATE };
    default:
      return state;
  }
}